module.exports = __webpack_public_path__ + "static/media/clear.a560c4be.svg";